import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Format, Text } from 'src/Components'

import styles from './SuccessMessage.module.scss'

const propTypes = {
  className: PropTypes.string,
  amount: PropTypes.number,
}

const SuccessMessage = ({ className, amount, ...restProps }) => (
  <div className={className} {...restProps}>
    <Text
      className={styles.headline}
      element='h1'
      size='xxxl'
      weight='light'
      variant='neutralCool'
      variantCount='900'
      paragraph
    >
      <FormattedMessage id='TYV.success.headline' defaultMessage='Very nice!' />
    </Text>
    <Text
      variant='neutralCool'
      variantCount='600'
      transform='uppercase'
      size='xs'
      weight='bold'
    >
      <FormattedMessage
        id='TYV.success.explain'
        defaultMessage='Your estimated home value is now:'
      />
    </Text>
    <Text className={styles.homeValue} variant='primary' weight='light'>
      <Format.Currency abbreviate value={amount} />
    </Text>
  </div>
)

SuccessMessage.propTypes = propTypes

export default SuccessMessage
